export default __webpack_public_path__ + "static/media/bg-coupon-default.e0221fdc.png";